<template>
  <aside class="main-sidebar text-secondary">
    <ul class="nav flex-column pl-3">
      <li class="nav-item">
        <a href="#" class="nav-link" @click="selectMenu('clients')">
          <i class="fas fa-users mr-2"></i>
          <span>Клиенты</span>
        </a>
      </li>

      <li class="nav-item">
        <a href="#" class="nav-link" @click="selectMenu('favorites')">
          <i class="fa fa-star sidebar-menu__icon mr-2"></i>
          <span>Избранные назначения</span>
        </a>
      </li>
      <li class="nav-item">
        <a href="#" class="nav-link" @click="logOut">
          <i class="fas fa-sign-out-alt mr-2"></i>
          <span>Выход</span>
        </a>
      </li>
    </ul>
  </aside>
</template>

<script>
  export default {
    name: "Menu",

    methods: {
      selectMenu(item) {
        this.$store.dispatch('CHANGE_VIEW', item);
        this.$store.dispatch('CHOOSE_CLIENT', null);
      },

      logOut() {
        try {
          this.$store.dispatch('LOG_OUT');
        } catch(e) {
          this.$store.dispatch('ERROR', e);
        }
      },
    },
  };
</script>
